import { useFormStage, useWalletAddressProviderApi } from 'BreetHooks';
import { type ReactNode, useMemo } from 'react';

import { requestPaymentUsdStageTitle, type USDWITHDRAWREQUESTSTAGETYPE } from '../../../DialogWithdrawRequest.helpers';
import { UsdWithdrawRequestContext } from './FormContext';

export const UsdWithdrawRequestProvider = ({ children }: { children?: ReactNode }) => {
	const formStage = useFormStage<USDWITHDRAWREQUESTSTAGETYPE>(
		'withdraw-funds',
		[
			'withdraw-funds',
			'add-wallet-address',
			'saved-wallet-address',
			'manage-wallet-address',
			'scan-wallet-address',
			'crypto-transaction-details',
		],
		requestPaymentUsdStageTitle
	);

	const walletAddressProviderValue = useWalletAddressProviderApi();

	const providerValue = useMemo(() => ({ ...walletAddressProviderValue, formStage }), [walletAddressProviderValue, formStage]);

	return <UsdWithdrawRequestContext.Provider value={providerValue}>{children}</UsdWithdrawRequestContext.Provider>;
};
